import {Component, h, Host, Prop} from '@stencil/core';
import {MediaGallery} from "@modules/search/suggestions/presentation/viewModels/MediaGallery";
import {BootstrapModalService} from "@modules/search/suggestions/infrastructure/services/BootstrapModalService";
import {ModalServicePort} from "@modules/search/suggestions/application/ports/output/ModalServicePort";

@Component({
    tag: 'product-viewer',
    styleUrl: 'product-viewer.css',
    scoped: true,
})
export class ProductViewer {
    @Prop() mediaGallery: string;

    private gallery: MediaGallery;

    async componentWillLoad() {
        this.gallery = JSON.parse(this.mediaGallery);
    }

    async componentDidRender() {
        if (this.gallery.promotionBadgeDescription != undefined && this.gallery.promotionBadgeDescription.length != 0) {
            document.getElementById('promotion-badge').style.display = "block";
        }
        if (this.gallery.pictogramDTOs != undefined && this.gallery.pictogramDTOs.length != 0) {
            document.getElementById('pictogram').style.display = "block";
        }
    }

    handleProductThumbnailImageMouseOver(imageSrc: string) {
        const mainImage = document.getElementById('main-image') as HTMLImageElement;
        if (mainImage) {
            mainImage.src = imageSrc;
        }
    }

    openPopin(imageSrc: string) {
        const modalService: ModalServicePort = new BootstrapModalService(
            {
                tagName: 'product-viewer-popin',
                props: [
                    {name: 'imageUrl', value: imageSrc}
                ]
            }
        );
        modalService.open();
    }

    render() {

        return (
            <Host>
                <div class="d-flex">
                    <div class="d-flex flex-column mr-3 justify-content-center">
                        {
                            this.gallery.imageDTOS.map((viewModel, index) => (
                                <img id={`thumbnail-image-${index + 1}`} data-testid={`thumbnail-image-${index + 1}`}
                                     class="border-1 mb-2" width="66" height="66" role="button"
                                     src={viewModel.thumbnailUrl}
                                     alt=""
                                     onClick={() => this.openPopin(viewModel.mainUrl)}
                                     onMouseOver={() => this.handleProductThumbnailImageMouseOver(viewModel.mainUrl)}
                                />
                            ))
                        }
                    </div>
                    <div>
                        <div class="promotion-badge" id="promotion-badge"
                             style={{display: "none"}}>{this.gallery.promotionBadgeDescription}</div>
                        <div class="pictogram" id="pictogram" style={{display: "none"}}>
                            {
                                this.gallery.pictogramDTOs && this.gallery.pictogramDTOs.map(
                                    (pictogram) =>
                                        <img class="new-pictogram" data-testid="new-pictogram" role="img"
                                             style={{display: "inline-block", width: "36px", height: "36px"}}
                                             src={pictogram.url}
                                             alt={pictogram.code}
                                        />
                                )
                            }
                        </div>
                        <img id="main-image" data-testid="main-image" role="button"
                             width="430" height="430"
                             src={this.gallery.imageDTOS[0].mainUrl}
                             alt=""
                             onClick={() => this.openPopin(document.getElementById('main-image').getAttribute('src'))}
                        />
                    </div>
                </div>
            </Host>
        );
    }
}
